// config
import * as http from 'utils/http';
import config from 'config';

// Could be moved in next iteration to tenant config
const getFilterViews = async (args) => {
  const endpoint = `${config.API_URL}price-negotiation/filter-views/`;
  const data = await http.get(`${endpoint}`);
  return data;
};

export default getFilterViews;
